import View from './Application';
import enhancer from './Application.enhancer';

const Application = enhancer(View);

export default Application;
